import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Container,
  Wrapper,
  KeyboardView,
  Animation
} from "app/NativeComponents/common";
import {
  NewHeader,
  ConfirmInlineButton,
  BottomNavBar,
  InputBox,
  ConfirmLabel,
  SelectBox,
  GhostButton
} from "app/NativeComponents/snippets";

import {
  popSidePanel,
  updateCustomFields,
  dismissMobileKeyboard
} from "app/NativeActions";

class NewLeadgroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      group_title: "",
      loading: false
    };

    this._group_title = React.createRef();
    this.handleBack = this.handleBack.bind(this);
    this.createFieldGroup = this.createFieldGroup.bind(this);
  }

  componentDidMount() {}

  handleBack() {
    dismissMobileKeyboard();
    this.props.popSidePanel();
  }

  checkIfNeedsToSave() {
    const { group_title } = this.state;
    if (!!group_title) {
      return true;
    }

    return false;
  }

  createFieldGroup() {
    this.props.updateCustomFields({
      token: this.props.token,
      type: "create_custom_field_group",
      title: this.state.group_title,
      custom_field_group_id: "new_field_group",
      onLoading: () => {
        this.setState({
          loading: true
        });
      },
      onSuccess: results => {
        this.setState({
          loading: false
        });
        this.props.popSidePanel();
      },
      onError: () => {
        this.setState({
          loading: false
        });
      }
    });
  }

  render() {
    const { edit_group_info, colors } = this.props;
    const { group_title, loading, deleting } = this.state;
    return (
      <Container>
        <NewHeader
          title={"New Group"}
          subtitle={""}
          leftButton={{
            icon: "arrow-back",
            onPress: () => {
              this.handleBack();
            }
          }}
        />

        <KeyboardView style={{ flex: 1 }}>
          <InputBox
            input_ref={this._group_title}
            autoFocus={true}
            name="group_title"
            disabled={loading}
            returnKeyType="done"
            placeholder={
              !!group_title ? "Group name" : "Enter a name for this group"
            }
            onFocus={() => {}}
            onChange={value => {
              this.setState({
                group_title: value
              });
            }}
            blurOnSubmit={true}
            value={group_title}
            input_type="text"
            require_confirm={true}
            has_changed={this.checkIfNeedsToSave()}
            submit_button_primary={true}
            submit_button_title={"Create Group"}
            onSubmit={this.createFieldGroup}
            onSubmitEditing={this.createFieldGroup}
            loading={this.state.loading}
          />
        </KeyboardView>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, native, settings, group, modal }) => {
  const { token, user } = auth;
  const { platform, device, isMobile } = native;
  const { colors } = settings;
  const { side_panel_views } = modal;

  return {
    token,
    user,
    platform,
    device,
    isMobile,
    colors,
    side_panel_views
  };
};

export default connect(mapStateToProps, {
  popSidePanel,
  updateCustomFields
})(NewLeadgroup);
